import {
  Wifi, Coffee, BellRing, Car, Snowflake, Tv, ShieldCheck, Bath, BedDouble, Clock, KeyRound,
  Sparkles, UtensilsCrossed, Briefcase, Accessibility, Dog, MapPin, Star,
} from "lucide-react";

export const SERVICE_ICONS = {
  wifi: { Icon: Wifi, label: "Wi-Fi" },
  coffee: { Icon: Coffee, label: "Café" },
  bell: { Icon: BellRing, label: "Recepção" },
  car: { Icon: Car, label: "Estacionamento" },
  snowflake: { Icon: Snowflake, label: "Ar-condicionado" },
  tv: { Icon: Tv, label: "TV" },
  shield: { Icon: ShieldCheck, label: "Segurança" },
  bath: { Icon: Bath, label: "Banheiro" },
  bed: { Icon: BedDouble, label: "Cama" },
  clock: { Icon: Clock, label: "Horário" },
  key: { Icon: KeyRound, label: "Chave / acesso" },
  sparkles: { Icon: Sparkles, label: "Limpeza" },
  utensils: { Icon: UtensilsCrossed, label: "Refeições" },
  briefcase: { Icon: Briefcase, label: "Negócios" },
  accessibility: { Icon: Accessibility, label: "Acessibilidade" },
  dog: { Icon: Dog, label: "Pet" },
  map: { Icon: MapPin, label: "Localização" },
  star: { Icon: Star, label: "Destaque" },
};

export const CATEGORY_LABELS = { quartos: "Quartos", suites: "Suítes", fachada: "Fachada", areas: "Áreas do hotel", outros: "Outros" };
export const SECTION_LABELS = { banner: "Banner principal", galeria: "Galeria", acomodacao: "Acomodação" };

export function waLink(content, text) {
  if (!content?.whatsapp_number) return null;
  return `https://wa.me/${content.whatsapp_number}?text=${encodeURIComponent(text || "")}`;
}

export const roomMessage = (c, room) =>
  (room.whatsapp_message || c.whatsapp_room_message || c.whatsapp_message || "").split("{acomodacao}").join(room.name);

export const fullAddress = (c) =>
  `${c.address_street} - ${c.address_district}, ${c.address_city} - ${c.address_state}, ${c.address_cep}`;

export const mapsEmbed = (c) => `https://www.google.com/maps?q=${encodeURIComponent(fullAddress(c))}&output=embed`;
export const mapsDir = (c) => `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(fullAddress(c))}`;
export const telHref = (phone) => `tel:+55${(phone || "").replace(/\D/g, "")}`;
